import React, {PropTypes} from "react";

class TeamInfo extends React.Component {

  constructor() {
    super();
    this.viewMore = this.viewMore.bind(this);
  }

  viewMore() {
    let requestObject = new Object();
    requestObject.empId = this.props.attendanceMain.empId;
    this.props.viewDetails(requestObject);
  }

  render() {
    const stylePaper = {
      height: "100%",
      width: "85%",
      padding: 0,
      marginTop: 20,
      textAlign: 'center',
      display: 'inline-block',
      borderStyle: 'solid',
      borderColor: '#616161'
    };

    return (
      <div >
        <div style={{textAlign: 'left', paddingTop: '0px', "font-family": '"ProximaNova-Regular", "sans-serif"'}}>
          <div className="col-md-6" style={{paddingBottom: '0px', paddingLeft: '20px'}}>
            <label style={{paddingTop: '10px', paddingBottom: '0px', paddingLeft: '40px'}}>Immediate Reporting:</label>
            <label style={{
              color: "#428BCA",
              'font-weight': 'bold',
              'font-size': '15',
              paddingTop: '0px',
              paddingBottom: '0px',
              paddingLeft: '40px'
            }}> {this.props.attendanceMain.reportingManager } </label>
            <br/>
            <img src="/public/images/totalTime.png" style={{paddingRight: '19px', marginLeft: '-3'}}/>
            <label style={{paddingTop: '0px', paddingBottom: '0px'}}>Average Working Hours:</label>
            <label style={{
              color: "#428BCA",
              'font-weight': 'bold',
              'font-size': '15',
              paddingTop: '0px',
              paddingBottom: '0px',
              paddingLeft: '20px',
            }}> {this.props.attendanceMain.avgWorkHours } </label>
            <br/>

          </div>
          <div className="col-md-6" style={{paddingBottom: '0px', marginLeft: '0px'}}>
            <div style={{marginTop: '0px'}}>
              <img src="/public/images/down-arrow.png" style={{paddingRight: '10px'}}/>
              <label style={{paddingTop: '0px', paddingBottom: '10px'}}>Average In Time:</label>

              <label style={{
                color: "#5CB85C",
                'font-weight': 'bold',
                'font-size': '15',
                paddingLeft: '20px',
                paddingTop: '0px',
                paddingBottom: '10px'
              }}>{this.props.attendanceMain.avgInTime } </label><br/>
              <img src="/public/images/up-arrow.png" style={{paddingRight: '10px'}}/>
              <label style={{paddingTop: '0px', paddingBottom: '0px'}}>Average Out Time:</label>
              <label style={{
                color: "#d9534f",
                'font-weight': 'bold',
                'font-size': '15',
                paddingLeft: '10px',
                paddingTop: '0px',
                paddingBottom: '10px'
              }}>{this.props.attendanceMain.avgOutTime } </label><br/>


            </div>
          </div>


        </div>

      </div>

    );
  }
}

TeamInfo.propTypes = {};

export default TeamInfo;





/** WEBPACK FOOTER **
 ** ./src/feature/attendance/TeamAttendance/TeamInfoSummary.js
 **/